<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Fornecedores</h1>
    <button class="btn btn-primary" (click)="novoFornecedor()">Incluir Novo Fornecedor</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por Razão Social, Nome Fantasia, CNPJ..." [(ngModel)]="searchTerm" (input)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Razão Social</th>
          <th scope="col">Nome Fantasia</th>
          <th scope="col">CNPJ</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fornecedor of paginatedFornecedores">
          <th scope="row">{{ fornecedor.id }}</th>
          <td>{{ fornecedor.razaoSocial }}</td>
          <td>{{ fornecedor.nomeFantasia }}</td>
          <td>{{ fornecedor.cnpj | mask: '00.000.000/0000-00' }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarFornecedor(fornecedor.id)">Editar</button>
            <button type="button" class="btn btn-danger btn-sm" (click)="deleteFornecedor(fornecedor.id)">Excluir</button>
          </td>
        </tr>
        <tr *ngIf="paginatedFornecedores.length === 0">
          <td colspan="5" class="text-center text-muted py-4">Nenhum fornecedor encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>
